import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { FloatingCTA } from './components/FloatingCTA';
import { PurchasePopup } from './components/PurchasePopup';
import { Hero } from './components/sections/Hero';
import { Stats } from './components/sections/Stats';
import { BeforeAfter } from './components/sections/BeforeAfter';
import { PainPoints } from './components/sections/PainPoints';
import { Volumes } from './components/sections/Volumes';
import { Deliverables } from './components/sections/Deliverables';
import { Bonuses } from './components/sections/Bonuses';
import { Offer } from './components/sections/Offer';
import { Guarantee } from './components/sections/Guarantee';
import { Testimonials } from './components/sections/Testimonials';
import { Author } from './components/sections/Author';
import { Faq } from './components/sections/Faq';
import { Footer } from './components/sections/Footer';
export function App() {
  return <div className="w-full overflow-x-hidden bg-ink-950" data-id="element-0" data-mp="23v2r0wxj8p28">
      <MetaPixel data-id="element-1" data-mp="3ikqzm1my986s" />
      <main className="w-full" data-id="element-2" data-mp="3ij64oawq3n8e">
        <Hero data-id="element-3" data-mp="3ihv0i9zd8dgr" />
        <Stats data-id="element-4" data-mp="3mljat0fdtn5p" />
        <BeforeAfter data-id="element-5" data-mp="3ml14tc2x3ukl" />
        <PainPoints data-id="element-6" data-mp="3mkhn9wh6j873" />
        <Volumes data-id="element-7" data-mp="3mjztd6hzp62c" />
        <Deliverables data-id="element-8" data-mp="3mjg8pi0yg3km" />
        <Bonuses data-id="element-9" data-mp="3rcj6y3gog175" />
        <Offer data-id="element-10" data-mp="3rbzmaezn6ypf" />
        <Guarantee data-id="element-11" data-mp="3rdki07xp0nov" />
        <Testimonials data-id="element-12" data-mp="3rd1all5o5hp3" />
        <Author data-id="element-13" data-mp="3relvsk63foaa" />
        <Faq data-id="element-14" data-mp="5orv1p50w72" />
      </main>
      <Footer data-id="element-15" data-mp="4wxfu7a14id" />
      <FloatingCTA afterElementId="hero-cta" data-id="element-16" data-mp="5gel8p3rovc" />
      <PurchasePopup data-id="element-17" data-mp="2zl3dbpgpde7f" />
    </div>;
}